import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "modal-mask"
}
const _hoisted_2 = { class: "modal-wrapper" }
const _hoisted_3 = { class: "modal-header" }
const _hoisted_4 = {
  key: 0,
  class: "modal-body"
}
const _hoisted_5 = {
  key: 1,
  class: "modal-form",
  id: "formEmbed"
}

import { onUpdated } from "vue";




export default /*@__PURE__*/_defineComponent({
  __name: 'UnitModal',
  props: {
  show: Boolean,
  showForm: Boolean,
  lotId: String,
  isWideScreen: Boolean
},
  setup(__props) {

const props = __props
onUpdated(()=>{
  const testScript = document.createElement("script");
  testScript.innerHTML = `hbspt.forms.create({
                          region: "na1",
                          portalId: "1763197",
                          formId: "8cc36b0f-f85d-47bb-849a-5e59d82d449d"
                });`
  var modalTest = document.querySelector('#formEmbed');
  modalTest?.appendChild(testScript);
  var interval = setTimeout(()=>{
    var inputData = document.querySelector('iframe');
    if(inputData){
      var test = inputData!.contentWindow!.document.querySelector('input[name=lot_number_interested_in__np_]');
      test!.value = props.lotId;
    }
  }, 1000);

})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Transition, { name: "modal" }, {
    default: _withCtx(() => [
      (__props.show)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", {
                class: _normalizeClass(["modal-container", { 'wide-screen-modal': __props.isWideScreen}])
              }, [
                _createElementVNode("button", {
                  class: "modal-close-button",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
                }),
                _createElementVNode("div", _hoisted_3, [
                  _renderSlot(_ctx.$slots, "header", {}, () => [
                    _cache[1] || (_cache[1] = _createTextVNode("default header", -1))
                  ])
                ]),
                (!__props.showForm)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                      _renderSlot(_ctx.$slots, "body", {}, () => [
                        _cache[2] || (_cache[2] = _createTextVNode("default body", -1))
                      ])
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_5))
              ], 2)
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 3
  }))
}
}

})